/* Page « Muse » (template product.jellybra-muse, 16/10/2026) : annonce, menu, galerie, couleur/taille → variante (lot de 1),
   calculateur de taille, ajout au panier (tiroir du thème), dates de livraison, vidéos, presse, avis.
   Suivi CRO : les clics marqués data-cro sont lus par cro-tracker.js ; ici seulement window.croTrack pour la vidéo lue. */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var racine = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var LG = document.documentElement.lang || 'fr';

  /* ── Annonce : trois messages qui défilent ── */
  (function () {
    var b = $('[data-mu-annonce]'); if (!b) return;
    var m = $$('.mu-annonce__txt', b), i = 0, t;
    function voir(n) { m[i].classList.remove('is-on'); i = (n + m.length) % m.length; m[i].classList.add('is-on'); }
    function auto() { clearInterval(t); t = setInterval(function () { voir(i + 1); }, 4000); }
    $('[data-mu-annonce-prec]', b).addEventListener('click', function () { voir(i - 1); auto(); });
    $('[data-mu-annonce-suiv]', b).addEventListener('click', function () { voir(i + 1); auto(); });
    auto();
  })();

  /* ── Menu mobile ── */
  (function () {
    var t = $('[data-mu-menu]'); if (!t) return;
    // Sorti de sa section : le thème y crée un empilement qui le faisait passer sous la galerie (16/10).
    document.body.appendChild(t);
    $$('[data-mu-menu-ouvrir]').forEach(function (b) { b.addEventListener('click', function () { t.hidden = false; document.documentElement.style.overflow = 'hidden'; }); });
    $$('[data-mu-menu-fermer]', t).forEach(function (b) { b.addEventListener('click', function () { t.hidden = true; document.documentElement.style.overflow = ''; }); });
  })();

  /* ── Compteur du panier : suit le thème (événement « ajaxCart ») ── */
  function majCompte() {
    fetch(racine + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
      $$('[data-mu-compte]').forEach(function (e) { e.textContent = c.item_count; e.hidden = !c.item_count; });
    }).catch(function () {});
  }
  window.addEventListener('ajaxCart', majCompte);

  var P = $('[data-mu-produit]');
  if (P) {
    var D = JSON.parse($('[data-mu-variantes]').textContent), T = D.t;
    /* les traductions Shopify arrivent échappées (n&#39;est) : on les décode */
    var dec = document.createElement('textarea'); Object.keys(T).forEach(function (k) { if (typeof T[k] === 'string') { dec.innerHTML = T[k]; T[k] = dec.value; } });
    var piste = $('[data-mu-piste]', P), diapos = $$('.mu-galerie__diapo', P), vigs = $$('.mu-galerie__vig', P);
    var mobile = function () { return !window.matchMedia('(min-width: 750px)').matches; };

    /* ── Galerie : vignettes (mobile), aller à la photo d'une couleur ── */
    // Mobile : photo i en tête du carrousel. Ordinateur : grille de 2 colonnes (paires), pas de carrousel.
    var pas = function () { return diapos[0] ? diapos[0].getBoundingClientRect().width : piste.clientWidth; };
    var parVue = function () { return mobile() ? 1 : 2; };
    var fleches = $$('[data-mu-gal]', P);
    function courant() { return Math.round(piste.scrollLeft / pas()); }
    function majFleches(cible) {
      var i = typeof cible === 'number' ? cible : courant(), n = parVue(), max = diapos.length - n;
      fleches.forEach(function (f) { f.disabled = +f.dataset.muGal < 0 ? i <= 0 : i >= max; });
      vigs.forEach(function (v, k) { v.classList.toggle('is-on', k >= i && k < i + n); });
      var on = vigs[i]; if (on && mobile()) on.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    }
    function voirPhoto(i, doux) {
      if (i < 0 || !diapos[i]) return;
      var n = parVue(); i = Math.min(Math.floor(i / n) * n, Math.max(0, diapos.length - n));
      if (!mobile()) return; // ordinateur : grille, toutes les photos sont déjà visibles en défilant
      piste.scrollTo({ left: i * pas(), behavior: doux ? 'smooth' : 'auto' });
      majFleches(i);
    }
    vigs.forEach(function (v) { v.addEventListener('click', function () { voirPhoto(+v.dataset.i, true); }); });
    fleches.forEach(function (f) { f.addEventListener('click', function () { voirPhoto(Math.max(0, courant() + +f.dataset.muGal * parVue()), true); }); });
    var att;
    piste.addEventListener('scroll', function () { clearTimeout(att); att = setTimeout(majFleches, 120); }, { passive: true });
    piste.addEventListener('scrollend', function () { majFleches(); });
    majFleches();

    /* ── Ordinateur : colonne d'infos fixée sous l'en-tête pendant les photos (comme Madam Muse) ; sur la fin elle défile
       avec la dernière paire et les deux se terminent au même niveau, sans blanc sous la galerie. ── */
    (function () {
      var infos = $('.mu-infos', P), entete = $('.mu-entete');
      function caler() { infos.style.top = mobile() ? '' : (entete ? entete.offsetHeight : 0) + 'px'; }
      caler(); window.addEventListener('resize', caler);
    })();

    /* ── Couleur + taille → variante « lot de 1 » ── */
    var champId = $('[data-mu-id]', P), nomC = $('[data-mu-nom-couleur]', P), nomT = $('[data-mu-nom-taille]', P);
    var btnC = $$('.mu-pastille-c', P), btnT = $$('.mu-taille', P);
    var actif = function (l) { return (l.filter(function (b) { return b.classList.contains('is-on'); })[0] || l[0]).dataset.nom; };
    var choix = { c: actif(btnC), t: actif(btnT) };
    function variante(c, t) { for (var i = 0; i < D.v.length; i++) if (D.v[i].c === c && D.v[i].t === t) return D.v[i]; return null; }
    function maj() {
      btnC.forEach(function (b) { var on = b.dataset.nom === choix.c; b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on); });
      btnT.forEach(function (b) {
        var on = b.dataset.nom === choix.t, v = variante(choix.c, b.dataset.nom);
        b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on); b.classList.toggle('mu-epuise', !!v && !v.d);
      });
      nomC.textContent = choix.c; nomT.textContent = choix.t || '';
      var v = variante(choix.c, choix.t);
      if (v) champId.value = v.id;
    }
    btnC.forEach(function (b) { b.addEventListener('click', function () {
      choix.c = b.dataset.nom; maj();
      var m = b.dataset.media; if (m) diapos.forEach(function (d, k) { if (d.dataset.media === m) voirPhoto(k, true); });
      // 18/10/2026 (Kubi) : ordinateur (grille) : la photo de la couleur choisie passe en tête (classe is-choisie, CSS order:-1)
      // et on remonte jusqu'à la galerie si elle est sortie de l'écran. Sans effet sur mobile (défilement ci-dessus).
      if (m) diapos.forEach(function (d) { d.classList.toggle('is-choisie', d.dataset.media === m); });
      if (m && !mobile()) { var rg = piste.getBoundingClientRect(), ent = document.querySelector('.mu-entete'), hh = ent ? ent.offsetHeight : 0;
        if (rg.top < hh) window.scrollBy({ top: rg.top - hh, behavior: 'smooth' }); }
    }); });
    btnT.forEach(function (b) { b.addEventListener('click', function () { choix.t = b.dataset.nom; maj(); }); });
    maj();

    /* ── Aide au choix de la taille (proposition A) : bouton qui ouvre le panneau, tour de dos puis bonnet en puces,
       la taille se sélectionne seule. Le guide est en EU ; FR = EU + 15, UK/US en pouces (32 à 46), bonnets E/F = DD/E (UK), DD/DDD (US). ── */
    (function () {
      var calc = $('[data-mu-calc]', P); if (!calc) return;
      /* 23/10/2026 : tours de dos lus sur la fiche (D.dos, Jelly Curve™ jusqu'au 110 pour le 5XL), sinon 70 à 105 */
      var DOS = D.dos || [70, 75, 80, 85, 90, 95, 100, 105], BON = ['B', 'C', 'D', 'E', 'F'], POUCES = DOS.map(function (x) { return 32 + (x - 70) / 5 * 2; });
      var SYS = {
        EU: { d: DOS, b: BON },
        FR: { d: DOS.map(function (x) { return x + 15; }), b: BON },
        UK: { d: POUCES, b: ['B', 'C', 'D', 'DD', 'E'] },
        US: { d: POUCES, b: ['B', 'C', 'D', 'DD', 'DDD'] },
        IT: { d: DOS.map(function (x, i) { return i + 1; }), b: BON }   /* 17/10/2026 (Kubi) : taille italienne, correspondance Intimissimi (1 = EU 70) */
      };
      var ouvrir = $('[data-mu-calc-ouvrir]', calc), panneau = $('#mu-calc-panneau', calc);
      var boxD = $('[data-mu-dos]', calc), boxB = $('[data-mu-bonnets]', calc), wB = $('[data-mu-bonnets-w]', calc);
      var res = $('[data-mu-calc-res]', calc), ex = $('[data-mu-calc-ex]', calc), sysBtns = $$('[data-mu-systemes] button', calc);
      var sys = calc.dataset.systeme || 'EU', iD = null, iB = null;
      btnT.forEach(function (b) { b.dataset.pour = T.pour; });
      ouvrir.addEventListener('click', function () {
        var o = panneau.hidden; panneau.hidden = !o; ouvrir.setAttribute('aria-expanded', o);
      });
      function puce(txt, on, off, label, fn) {
        var b = document.createElement('button'); b.type = 'button'; b.className = 'mu-puce-c' + (on ? ' is-on' : '');
        b.textContent = txt; b.disabled = off; b.setAttribute('aria-pressed', !!on);
        b.setAttribute('data-cro', 'guide_taille'); b.setAttribute('data-cro-label', label);
        b.addEventListener('click', fn); return b;
      }
      function dessiner() {
        var S = SYS[sys]; ex.textContent = '(' + S.d.slice(1, 4).join(', ') + '…)';
        boxD.textContent = ''; boxB.textContent = '';
        S.d.forEach(function (x, i) { boxD.appendChild(puce(x, i === iD, false, 'dos:' + sys + x, function () { iD = i; dessiner(); resultat(); })); });
        S.b.forEach(function (x, i) { boxB.appendChild(puce(x, i === iB, iD === null, 'bonnet:' + sys + x, function () { iB = i; dessiner(); resultat(); })); });
        wB.classList.toggle('is-attente', iD === null);
      }
      /* 17/10/2026 (Kubi) : taille habituelle et mesures enregistrées avec la commande (propriétés « _ » : visibles dans la
         commande Shopify, pas par la cliente). */
      var formP = $('[data-mu-form]', P), props = {};
      function noter(nom, val) {
        if (!formP) return;
        if (!props[nom]) { props[nom] = document.createElement('input'); props[nom].type = 'hidden'; props[nom].name = 'properties[' + nom + ']'; formP.appendChild(props[nom]); }
        props[nom].value = val;
      }
      /* 17/10/2026 (Kubi) : aide à la mesure (snippets/muse-mesure). Tableau fournisseur AliExpress/1688 (corps) : tour sous la
         poitrine (pouces) → tour de dos, écart poitrine − sous-poitrine (pouces) → bonnet (4,5-5,5 B … 8,5-9,5 F). */
      var mes = $('[data-mu-mes]', calc), mesO = $('[data-mu-mes-ouvrir]', calc);
      if (mes && mesO) {
        mesO.addEventListener('click', function () { mes.hidden = !mes.hidden; });
        var inS = $('[data-mu-mes-sous]', mes), inP = $('[data-mu-mes-sur]', mes);
        var lireMes = function () {
          var a = parseFloat(inS.value), b = parseFloat(inP.value); if (!(a > 40 && b > a)) return;
          var p = a / 2.54, e = (b - a) / 2.54;
                    var i = p < 27 ? -1 : p < 29 ? 0 : p < 31 ? 1 : p < 33 ? 2 : p < 35 ? 3 : p < 37 ? 4 : p < 39 ? 5 : p < 41 ? 6 : p < 43 ? 7 : p < 45 ? 8 : 9;   // sous-poitrine 27-29" → 32 (EU 70) … 41-43" → 46 (EU 105)
          var k = e < 5.5 ? 0 : e < 6.5 ? 1 : e < 7.5 ? 2 : e < 8.5 ? 3 : e < 9.5 ? 4 : 5;
          noter('_Mesures', a + ' / ' + b + ' cm');
          if (i < 0 || i >= DOS.length || k > 4) { iD = null; iB = null; dessiner(); res.className = 'mu-calc__res'; res.textContent = mes.dataset.hors; return; }
          iD = i; iB = k; dessiner(); resultat();
          if (res.classList.contains('is-ok')) { var s = res.querySelector('span'); if (s) s.textContent = mes.dataset.res.replace('{n}', SYS[sys].d[iD] + SYS[sys].b[iB]) + ' ' + s.textContent; }
        };
        inS.addEventListener('input', lireMes); inP.addEventListener('input', lireMes);
      }
      function resultat() {
        btnT.forEach(function (b) { b.classList.remove('is-reco'); });
        if (iD === null) { res.className = 'mu-calc__res'; res.textContent = T.attente_dos; return; }
        if (iB === null) { res.className = 'mu-calc__res'; res.textContent = T.attente_bonnet; return; }
        var n = SYS[sys].d[iD] + SYS[sys].b[iB], t = D.guide[DOS[iD]][BON[iB]];
        if (!t) { res.className = 'mu-calc__res'; res.textContent = T.hors.replace('{n}', n); return; }
        choix.t = t; maj();
        document.dispatchEvent(new CustomEvent('mu:guide', { detail: t }));   // version B (offre 3 lots) : la taille va à tous les soutiens-gorge
        noter('_Taille habituelle', n);   /* 17/10/2026 : gardée avec la commande (propriété cachée à la cliente) */
        /* 19/10/2026 : même guide affiché pour toutes les couleurs ; pour le Vieux rose (autre fournisseur, autre tableau) on note
           sa taille à lui, pour la commande fournisseur (propriété cachée) */
        if (D.guide2) noter('_Taille Vieux rose (fournisseur)', (D.guide2[DOS[iD]] || {})[BON[iB]] || '—');
        btnT.forEach(function (b) {
          if (b.dataset.nom !== t) return;
          b.classList.add('is-reco'); b.classList.remove('mu-flash'); void b.offsetWidth; b.classList.add('mu-flash');
        });
        res.className = 'mu-calc__res is-ok';
        res.innerHTML = '<svg aria-hidden="true" width="18" height="18" viewBox="0 0 20 20"><circle cx="10" cy="10" r="9" fill="#1a1a1a"/><path d="M6 10.2l2.7 2.6L14 7.6" stroke="#fff" stroke-width="1.8" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg><span>' +
          T.resultat.replace('{n}', n).replace('{t}', t) + '</span>';
      }
      sysBtns.forEach(function (b) { b.addEventListener('click', function () {
        sys = b.dataset.r; sysBtns.forEach(function (x) { var on = x === b; x.classList.toggle('is-on', on); x.setAttribute('aria-pressed', on); });
        dessiner(); resultat();
      }); });
      /* 20/10/2026 (Kubi) : arrivée depuis la carte de l'advertorial (snippets/adv-jelly5-guide) avec ?jb_th=<taille habituelle EU, ex. 80D> :
         on remet le guide sur cette taille (résultat affiché + propriétés de commande) ; la couleur et la taille viennent de ?variant=. */
      var th = /[?&]jb_th=(\d{2,3})([BCDEF])/.exec(location.search);
      if (th && DOS.indexOf(+th[1]) >= 0) { iD = DOS.indexOf(+th[1]); iB = BON.indexOf(th[2]); }
      // Choix manuel d'une autre taille : l'étiquette « pour vous » reste sur la taille conseillée.
      dessiner();
      if (iD !== null && iB !== null && iB >= 0) resultat();
      // 20/10/2026 (Abel) : version B, taille déjà trouvée sur l'advertorial → guide replié (rouvrable)
      if (th && iD !== null && iB >= 0 && $('.mu-lot--b', P)) { panneau.hidden = true; ouvrir.setAttribute('aria-expanded', false); }
    })();

    /* ── Offre 1+1 (snippets/muse-lot, 18/10/2026) : 1 ou 2 soutiens-gorge ; le 2e, couleur et taille au choix.
       Le prix (2 = 1,56 × le prix) vient de la remise automatique Shopify « Jelly 1+1 » (le 2e à -44 %). ── */
    var lot = $('[data-mu-lot]', P), lotN = 1, lot2 = { c: null, t: null, tTouchee: false };
    function pastilles2(box, sel, rappel) {
      box.innerHTML = '';
      btnC.forEach(function (b) {
        var x = document.createElement('button'); x.type = 'button'; x.title = b.dataset.nom; x.setAttribute('aria-label', b.dataset.nom);
        var cs = getComputedStyle(b); x.style.backgroundColor = cs.backgroundColor; x.style.backgroundImage = cs.backgroundImage; x.style.backgroundSize = 'cover'; x.style.backgroundPosition = 'center'; x.classList.toggle('is-on', b.dataset.nom === sel);
        x.addEventListener('click', function (e) { e.stopPropagation(); $$('button', box).forEach(function (o) { o.classList.toggle('is-on', o === x); }); rappel(b.dataset.nom); });
        box.appendChild(x);
      });
    }
    // tailles du 2e en petites puces (un <select> prend le style du thème, trop haut) ; box.value = taille choisie
    function tailles2(box, val, rappel) {
      box.innerHTML = ''; box.value = val;
      btnT.forEach(function (b) {
        var x = document.createElement('button'); x.type = 'button'; x.textContent = b.dataset.nom; x.classList.toggle('is-on', b.dataset.nom === val);
        x.addEventListener('click', function (e) { e.stopPropagation(); box.value = b.dataset.nom; $$('button', box).forEach(function (y) { y.classList.toggle('is-on', y === x); }); if (rappel) rappel(b.dataset.nom); });
        box.appendChild(x);
      });
    }
    function tailleSur(box, val) { box.value = val; $$('button', box).forEach(function (y) { y.classList.toggle('is-on', y.textContent === val); }); }
    var texteAjout = $('span', bouton0()) ? $('span', bouton0()).textContent : '';
    function bouton0() { return $('[data-mu-ajout]', P); }
    function majLot() {
      if (!lot) return;
      $$('[data-mu-lot-n]', lot).forEach(function (c) { var on = +c.dataset.muLotN === lotN; c.classList.toggle('is-on', on); c.setAttribute('aria-pressed', on); });
      var sp = $('span', bouton0()); if (sp) sp.textContent = lotN === 2 ? JSON.parse($('[data-mu-lot-txt]', lot).textContent) : lotN === 3 ? JSON.parse($('[data-mu-lot-txt3]', lot).textContent) : texteAjout;
      // version B : le total dans le bouton (prix affiché de l'offre, déjà dans la devise de la visiteuse)
      if (sp && B3 && lotN > 1) { var px = $('[data-mu-lot-n="' + lotN + '"] .mu-lot__px' + (lotN === 2 ? '.mu-lot__b' : ''), lot), s = px && $('s', px);
        var tx = px ? px.textContent.replace(s ? s.textContent : '', '').trim() : ''; if (tx) sp.textContent += ' · ' + tx; }
    }
    /* ── 20/10/2026 (Abel) : 3 offres (classe mu-lot--b, snippets/muse-lot) pour les visiteuses venues de la version B de
       l'advertorial témoignage. 2+1 = 3 variantes « Lot 3 », couleur et taille au choix pour le 2e et le 3e. ── */
    var B3 = lot && lot.classList.contains('mu-lot--b') && $('[data-mu-lot3]', lot), V3 = B3 ? JSON.parse(B3.textContent) : [], L3 = {};
    // Suivi CRO (20/10/2026, Abel) : la fiche note qu'elle s'affiche en 3 offres, sinon la visite ne le dit nulle part.
    // 25/10/2026 (cro-backend, test « modif 5 ») : version avec la pop-up culotte (<html data-mcu-v="culotte">, posé avant ce script
    // par snippets/muse-upsell-culotte) = page à part pour l'outil (#024) : « jelly-offre3-culotte ».
    var VP3 = document.documentElement.getAttribute('data-mcu-v') === 'culotte' ? 'jelly-offre3-culotte' : 'jelly-offre3';
    if (B3) (function vu(n) { if (window.croTrack) { try { croTrack('version_page', { label: VP3 }); } catch (e) {} } else if (n < 20) setTimeout(function () { vu(n + 1); }, 250); })(0);
    function variante3(c, t) { for (var i = 0; i < V3.length; i++) if (V3[i].c === c && V3[i].t === t) return V3[i]; return null; }
    if (lot) {
      var autre = btnC[(btnC.map(function (b) { return b.dataset.nom; }).indexOf(choix.c) + 1) % btnC.length];
      lot2.c = autre ? autre.dataset.nom : choix.c; lot2.t = choix.t;
      var nom2 = $('[data-mu-lot-nom]', lot), sel2 = $('[data-mu-lot-t]', lot);
      pastilles2($('[data-mu-lot-c]', lot), lot2.c, function (n) { lot2.c = n; nom2.textContent = n; });
      nom2.textContent = lot2.c; tailles2(sel2, lot2.t, function (n) { lot2.t = n; lot2.tTouchee = true; });
      // tant que la cliente n'a pas choisi la taille du 2e, elle suit celle du 1er (guide des tailles compris)
      btnT.forEach(function (b) { b.addEventListener('click', function () { if (!lot2.tTouchee) { lot2.t = b.dataset.nom; tailleSur(sel2, lot2.t); } }); });
      new MutationObserver(function () { if (!lot2.tTouchee && choix.t && choix.t !== lot2.t) { lot2.t = choix.t; tailleSur(sel2, lot2.t); } })
        .observe(btnT[0] ? btnT[0].parentNode : P, { attributes: true, subtree: true, attributeFilter: ['class'] });
      $$('[data-mu-lot-n]', lot).forEach(function (c) {
        var go = function () { lotN = +c.dataset.muLotN; majLot(); };
        c.addEventListener('click', go);
        c.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); go(); } });
      });
      lotN = 1;   // offre 1 cochée par défaut (Kubi, 18/10)
      // 26/10/2026 (Abel, tâche 17) : Jelly et Jelly Curve™ : 1+1 (2 soutiens-gorge) coché à l'arrivée, fiche 2 offres comme
      // 3 offres ; ?offre=1|2|3 (bouton de l'advertorial, 1+1 coché là aussi) garde le choix de la visiteuse.
      var D1P1 = false; try { var hP = JSON.parse($('[data-mu-panier]').textContent).h;
        D1P1 = hP === 'wireless-comfy-push-up-bra' || hP === 'wireless-comfy-push-up-bra-plus-size'; } catch (e) {}
      if (D1P1) lotN = 2;
      if (B3) {
        // design 1 (Abel, 20/10) : dans l'offre cochée, un encart par soutien-gorge (n° 1 = le choix du haut de la fiche).
        // Le 2e est le même pour 1+1 et 2+1 (objet lot2, lu à l'ajout du lot de 2) ; le 3e : L3[3].
        var noms = btnC.map(function (b) { return b.dataset.nom; }), i0 = noms.indexOf(choix.c), SG = JSON.parse($('[data-mu-sg-txt]', lot).textContent);
        // 20/10/2026 (Abel) : en B, la taille se choisit dans l'offre (boutons du haut masqués, snippets/muse-lot). Le guide
        // « Trouvez votre taille » la donne à tous ; une taille changée dans un encart ne change que ce soutien-gorge.
        L3[2] = lot2; L3[3] = { c: noms[(i0 + 2) % noms.length] || choix.c, t: choix.t, tTouchee: true };
        lot2.tTouchee = true;   // l'offre 1+1 de la fiche A ne fait plus suivre la taille du n° 1
        // n° 1 = le choix du haut de la fiche, mis à jour sans cliquer ses pastilles (leur clic fait défiler jusqu'à la photo)
        var cliquer = function (l, n) { if (l === btnC) choix.c = n; else choix.t = n; maj(); encarts(); };
        var encart = function (k, seul) {
          var s = k === 1 ? choix : L3[k], d = document.createElement('div'), h = document.createElement('p'), n = document.createElement('span'), b = document.createElement('b'), x = document.createElement('span');
          d.className = 'mu-sg' + (seul ? ' mu-sg--seul' : ''); h.className = 'mu-sg__h'; n.className = 'mu-sg__n'; n.textContent = k; b.textContent = seul ? SG.taille : SG.sg + ' ' + k; x.textContent = seul ? '· ' + (s.t || '') : '· ' + s.c + ' · ' + (s.t || '');
          if (!seul) h.appendChild(n); h.appendChild(b); h.appendChild(x); d.appendChild(h);
          var pc = document.createElement('div'); pc.className = 'mu-lot__pastilles';
          pastilles2(pc, s.c, function (v) { if (k === 1) cliquer(btnC, v); else { s.c = v; encarts(); } });
          var pt = document.createElement('div'); pt.className = 'pn-tailles mu-lot__tailles mu-sg__t'; pt.setAttribute('role', 'group');
          tailles2(pt, s.t, function (v) { if (k === 1) cliquer(btnT, v); else { s.t = v; s.tTouchee = true; encarts(); } });
          if (!seul) d.appendChild(pc); d.appendChild(pt); return d;
        };
        var encarts = function () {
          $$('[data-mu-sg]', lot).forEach(function (box) {
            var nb = +box.dataset.muSg; box.innerHTML = ''; for (var k = 1; k <= nb; k++) box.appendChild(encart(k, nb === 1));
            if (nb > 1) { var a = document.createElement('p'); a.className = 'mu-sg-astuce'; a.textContent = SG.astuce; box.appendChild(a); }
          });
        };
        document.addEventListener('mu:guide', function (e) { [2, 3].forEach(function (k) { L3[k].t = e.detail; }); encarts(); });
        btnC.forEach(function (b) { b.addEventListener('click', function () { setTimeout(encarts, 0); }); });
        encarts();
        // offre choisie sur l'advertorial (?offre=1|2|3), sinon 1 soutien-gorge (cochée sur l'advertorial)
        var o = +(new URLSearchParams(location.search).get('offre') || (D1P1 ? 2 : 1)); lotN = o >= 1 && o <= 3 ? o : (D1P1 ? 2 : 1);
      }
      majLot();
    }

    /* ── Ajout au panier : vrai formulaire /cart/add (suivi CRO), envoyé en AJAX puis tiroir du thème ── */
    var form = $('[data-mu-form]', P), bouton = $('[data-mu-ajout]', P), err = $('[data-mu-erreur]', P);
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var v = variante(choix.c, choix.t);
      if (!v || !v.d) { err.textContent = T.indispo; err.hidden = false; return; }
      var envoi = new FormData(form);
      if (lot && lotN === 2) {
        var v2 = variante(lot2.c, lot2.t);
        if (!v2 || !v2.d) { err.textContent = T.indispo; err.hidden = false; return; }
        var props = {}; envoi.forEach(function (val, k) { var m = /^properties\[(.+)\]$/.exec(k); if (m) props[m[1]] = val; });
        envoi = JSON.stringify({ items: [{ id: v.id, quantity: 1, properties: props }, { id: v2.id, quantity: 1, properties: props }] });
      }
      if (lot && lotN === 3) {
        var w = [variante3(choix.c, choix.t), variante3(L3[2].c, L3[2].t), variante3(L3[3].c, L3[3].t)];
        if (w.some(function (x) { return !x || !x.d; })) { err.textContent = T.indispo; err.hidden = false; return; }
        var props3 = {}; envoi.forEach(function (val, k) { var m = /^properties\[(.+)\]$/.exec(k); if (m) props3[m[1]] = val; });
        envoi = JSON.stringify({ items: w.map(function (x) { return { id: x.id, quantity: 1, properties: props3 }; }) });
      }
      err.hidden = true; bouton.disabled = true;
      fetch(racine + 'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: typeof envoi === 'string' ? { Accept: 'application/json', 'Content-Type': 'application/json' } : { Accept: 'application/json' }, body: envoi })
        .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); })
        .then(function () {
          bouton.disabled = false; majCompte();
          return fetch(racine + '?sections=side-cart', { credentials: 'same-origin' }).then(function (x) { return x.json(); }).then(function (sec) {
            if (window.ajaxCart && ajaxCart.load) ajaxCart.load({ sections: sec }, true); else location.href = racine + 'cart';
          }).catch(function () { location.href = racine + 'cart'; });
        })
        .catch(function (d) { bouton.disabled = false; err.textContent = (d && (d.description || d.message)) || T.erreur; err.hidden = false; });
    });

    /* ── Panier latéral, seulement s'il contient ce soutien-gorge (18/10/2026, Kubi) : « ajoutez-en un 2e » quand le nombre
       est impair, réassurance (30 jours, livraison, paiement) et carrousel de 5 vrais avis de la fiche. Le minuteur reste.
       Textes et prix : snippets/muse-lot (partie « panier »). Rien n'est ajouté aux paniers sans soutien-gorge. ── */
    (function () {
      var J = $('[data-mu-panier]'); if (!J) return;
      J = JSON.parse(J.textContent);
      var NOMS = ['HJ', 'Vanessa S.', 'Sarah J.', 'Cjame', 'Kate A.'];
      var ic = {
        g: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M12 3l7 3v5c0 4.5-3 7.8-7 9-4-1.2-7-4.5-7-9V6z"/><path d="M9 12l2 2 4-4"/></svg>',
        l: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><rect x="3" y="7" width="13" height="10" rx="1"/><path d="M16 10h3l2 3v4h-5"/><circle cx="7" cy="18" r="1.6"/><circle cx="18" cy="18" r="1.6"/></svg>',
        p: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><rect x="4" y="10" width="16" height="10" rx="2"/><path d="M8 10V7a4 4 0 0 1 8 0v3"/></svg>'
      };
      var avis = NOMS.map(function (n) {
        var a = $$('.mu-avis__rev').filter(function (x) { var e = $('.mu-avis__nom', x); return e && e.textContent.trim() === n; })[0]; if (!a) return '';
        var c = $('.mu-avis__corps', a), t = $('.mu-avis__t', a), txt = c ? c.textContent.replace(t ? t.textContent : '', '').trim() : '';
        var d = document.createElement('div'); d.textContent = txt;
        return '<div class="pn-avis"><span class="et">★★★★★</span> <span class="pn-ok">✓ ' + J.verifie + '</span><br>« ' + d.innerHTML + ' » <b>— ' + n + '</b></div>';
      }).filter(Boolean);
      var occupe = false, auto = null;
      function recharger() {
        return fetch(racine + '?sections=side-cart', { credentials: 'same-origin' }).then(function (x) { return x.json(); }).then(function (sec) {
          if (window.ajaxCart && ajaxCart.load) ajaxCart.load({ sections: sec }, true);
        });
      }
      function poser() {
        var tiroir = $('#cart'), lignes = tiroir && $('.rs-lignes', tiroir), corps = tiroir && $('.rs-corps', tiroir);
        if (!lignes || !corps || occupe) return;
        occupe = true;
        fetch(racine + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
          var q = 0; c.items.forEach(function (it) { if (it.handle === J.h) q += it.quantity; });
          $$('.pn-bloc', tiroir).forEach(function (e) { e.remove(); }); if (auto) { clearInterval(auto); auto = null; }
          if (!q) return;
          // 20/10/2026 : pas de « ajoutez-en un 2e » à côté d'un lot de 3 (offre de l'advertorial B). Depuis le 24/10/2026, le 2+1
          // = 3 « Lot 1 » (remise « 2+1 🎁 ») : à partir de 3 soutiens-gorge, plus d'encadré ; anciennes lignes « Lot 3 » idem.
          var lot3 = q >= 3 || c.items.some(function (it) { return it.handle === J.h && it.variant_options && it.variant_options[2] === '3'; });
          if (q % 2 === 1 && !lot3) {
            var o = document.createElement('div'); o.className = 'pn-offre pn-bloc';
            // pas de <select> dans le tiroir : le thème assombrit alors tout le panier → petites puces de taille
            o.innerHTML = '<p>' + J.offre + '</p><p class="pn-coul">' + J.couleur + ' <b></b></p><div class="mu-lot__pastilles"></div><div class="pn-tailles" role="group" aria-label="' + J.taille + '"></div><button type="button" class="pn-ajout" data-cro="panier_2e">' + J.ajouter + '</button>';
            var c2 = lot2.c || choix.c, t2 = choix.t || (btnT[2] && btnT[2].dataset.nom);
            var nomC2 = $('.pn-coul b', o); nomC2.textContent = c2;
            pastilles2($('.mu-lot__pastilles', o), c2, function (n) { c2 = n; nomC2.textContent = n; });
            var bt = $('.pn-tailles', o);
            btnT.forEach(function (b) {
              var x = document.createElement('button'); x.type = 'button'; x.textContent = b.dataset.nom; x.classList.toggle('is-on', b.dataset.nom === t2);
              x.addEventListener('click', function () { t2 = b.dataset.nom; $$('button', bt).forEach(function (y) { y.classList.toggle('is-on', y === x); }); });
              bt.appendChild(x);
            });
            $('.pn-ajout', o).addEventListener('click', function () {
              var v = variante(c2, t2), b = this; if (!v || !v.d) { b.textContent = T.indispo; return; }
              b.disabled = true;
              fetch(racine + 'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { Accept: 'application/json', 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] }) })
                .then(function () { majCompte(); return recharger(); }).catch(function () { b.disabled = false; });
            });
            lignes.parentNode.insertBefore(o, lignes.nextSibling);
          }
          var r = document.createElement('div'); r.className = 'pn-bloc';
          r.innerHTML = '<div class="pn-rassure"><div class="pn-r">' + ic.g + '<span>' + J.garantie + '</span></div><div class="pn-r">' + ic.l + '<span>' + J.livraison + '</span></div><div class="pn-r">' + ic.p + '<span>' + J.paiement + '</span></div></div>'
            + (avis.length ? '<div class="pn-car">' + avis.join('') + '</div><div class="pn-points">' + new Array(avis.length + 1).join('<i></i>') + '</div>' : '');
          corps.appendChild(r);
          var car = $('.pn-car', r), pts = $('.pn-points', r);
          if (car) {
            var pas = function () { return car.children[0].offsetWidth + 8; };
            var majP = function () { var i = Math.round(car.scrollLeft / pas()); $$('i', pts).forEach(function (p, k) { p.classList.toggle('on', k === i); }); };
            car.addEventListener('scroll', majP, { passive: true }); majP();
            auto = setInterval(function () { if (!document.body.contains(car)) { clearInterval(auto); return; } var i = Math.round(car.scrollLeft / pas()); car.scrollTo({ left: ((i + 1) % car.children.length) * pas(), behavior: 'smooth' }); }, 4000);
            car.addEventListener('touchstart', function () { clearInterval(auto); }, { passive: true });
          }
        }).catch(function () {}).then(function () { occupe = false; });
      }
      var minuterie = null;
      var plusTard = function () { clearTimeout(minuterie); minuterie = setTimeout(poser, 150); };
      window.addEventListener('ajaxCart', plusTard);
      var tir = $('#cart');
      if (tir) new MutationObserver(function (m) {
        // on ignore nos propres ajouts
        if (m.some(function (x) { return [].some.call(x.addedNodes, function (n) { return n.nodeType === 1 && !(n.classList && n.classList.contains('pn-bloc')) && !(n.closest && n.closest('.pn-bloc')); }); })) plusTard();
      }).observe(tir, { childList: true, subtree: true });
      plusTard();
    })();

    /* ── Dates de livraison (snippets/rs-dates-livraison : expédition J+1, livraison 5 à 6 jours après) ── */
    (function () {
      var e = $('[data-mu-livraison]', P); if (!e || !+e.dataset.l1) return;
      // « du 22 au 23 oct. » : le mois seulement sur la 2e date quand c'est le même (sur la 1re en anglais : « Oct 22 – 23 »).
      var d1 = new Date(+e.dataset.l1 * 1000), d2 = new Date(+e.dataset.l2 * 1000), meme = d1.getUTCMonth() === d2.getUTCMonth();
      var f = function (d, mois) {
        try { return new Intl.DateTimeFormat(LG, mois ? { day: 'numeric', month: 'short', timeZone: 'UTC' } : { day: 'numeric', timeZone: 'UTC' }).format(d); }
        catch (x) { return d.toLocaleDateString(); }
      };
      // fr : « du 22 au 23 oct. » ; en : « Oct 22 – 23 » ; autres langues : jour + mois sur les deux dates (formats locaux variés).
      var fr = /^fr/.test(LG), en = /^en/.test(LG), plein = !meme || !(fr || en);
      e.textContent = e.dataset.modele.replace('{d1}', f(d1, plein || en)).replace('{d2}', f(d2, plein || fr));
    })();

    /* ── Vidéos clientes : lecture plein écran au clic ── */
    (function () {
      var cartes = $$('.mu-videos__carte', P), vids = cartes.map(function (c) { return $('video', c); });
      cartes.forEach(function (c, k) {
        var v = vids[k];
        $('.mu-videos__btn', c).addEventListener('click', function () {
          vids.forEach(function (o, j) { if (o !== v) { o.pause(); cartes[j].classList.remove('is-playing'); } });
          v.muted = false; v.controls = true;
          if (v.webkitEnterFullscreen) { try { v.webkitEnterFullscreen(); } catch (x) {} }
          else if (v.requestFullscreen) { v.requestFullscreen().catch(function () {}); }
          v.play().catch(function () {});
          c.classList.add('is-playing');
        });
        v.addEventListener('pause', function () { if (!document.fullscreenElement) c.classList.remove('is-playing'); });
        v.addEventListener('ended', function () { c.classList.remove('is-playing'); v.controls = false; v.muted = true; });
      });
    })();

    /* ── Note du haut → avis ── */
    $$('[data-mu-vers-avis]').forEach(function (a) { a.addEventListener('click', function (e) { var c = $('#mu-avis'); if (c) { e.preventDefault(); c.scrollIntoView({ behavior: 'smooth' }); } }); });
  }

  /* ── As Seen In : onglets ── */
  $$('.mu-presse').forEach(function (r) {
    $$('[data-mu-onglet]', r).forEach(function (o) {
      o.addEventListener('click', function () {
        var id = o.dataset.muOnglet;
        $$('[data-mu-onglet]', r).forEach(function (x) { var on = x === o; x.classList.toggle('is-on', on); x.setAttribute('aria-selected', on); });
        $$('[data-mu-citation]', r).forEach(function (q) { q.hidden = q.dataset.muCitation !== id; });
      });
    });
  });

  /* ── Avis : voir plus (+5), tri (récents / avec photos), zoom des photos ── */
  (function () {
    var l = $('[data-mu-avis-liste]'); if (!l) return;
    var plus = $('[data-mu-avis-plus]'), tri = $('[data-mu-tri]'), vus = 5;
    var tous = $$('.mu-avis__rev', l);
    function rendre() {
      var ordre = tous.slice();
      if (tri.value === 'photos') ordre.sort(function (a, b) { return (+b.dataset.ph - +a.dataset.ph) || (+a.dataset.r - +b.dataset.r); });
      ordre.forEach(function (e, k) { l.appendChild(e); e.hidden = k >= vus; });
      plus.parentNode.hidden = vus >= tous.length;
    }
    plus.addEventListener('click', function () { vus += 5; rendre(); });
    tri.addEventListener('change', function () { vus = 5; rendre(); });
    rendre();
    var z = $('[data-mu-zoom-boite]');
    l.addEventListener('click', function (e) {
      var b = e.target.closest('[data-mu-zoom]'); if (!b || !z) return;
      $('img', z).src = b.dataset.muZoom; z.hidden = false;
    });
    if (z) z.addEventListener('click', function () { z.hidden = true; });
  })();
})();
